export enum GlobalModalType {
  FastOrder = 'fastOrder',
}
